import axios from "../api/api";

const fetchSingleOrder = async (id) => {
  const response = await axios.get(`/order?id=${id}`, {
    headers: {
      "Content-Type": "text/plain",
      Accept: "application/json, text/plain, */*",
    },
  });

  return response;
};

export default fetchSingleOrder;
